export enum ImportIdentifiers {
  TeamRegistration = 1,
  BranchInclusion = 2,
  ChannelHierarchy = 3,
  FocalPointChange = 4,
  ImportGoalsProducts = 5,
  ImportGoals = 6,
  
}